"use client";

import { useEffect } from "react";

export const PersonioModuleView = () => {
    useEffect(() => {
        window.addEventListener(
            "message",
            (e: MessageEvent) => {
                const iframe = document.querySelector<HTMLIFrameElement>("#personio-iframe");

                if (!iframe) return; // Ensure iframe exists

                const eventData = e.data as [string, number]; // Type assertion for expected data structure
                const eventName = eventData[0];
                const data = eventData[1];

                if (eventName === "setHeight") {
                    iframe.style.height = `${data}px`;
                    const headerBb = document
                        .querySelector<HTMLElement>("header")
                        ?.getBoundingClientRect();

                    window.top?.scrollTo(
                        0,
                        iframe.offsetTop - ((headerBb?.top ?? 0) + (headerBb?.height ?? 0) + 10),
                    );
                }
            },
            false,
        );
    }, []);

    return (
        <iframe
            title="Personio"
            id="personio-iframe"
            src="https://raabe.jobs.personio.de"
            width="100%"
        ></iframe>
    );
};
